import { createApiService } from "../../../core/api/apiService";
import type { AppointmentEventDto } from "../types/appointmentEventTypes";
import type { AppointmentFormsReviewDto } from "../types/appointmentFormTypes";
import type {
  AppointmentDto,
  CreateAppointmentDto,
  UpdateAppointmentDto,
} from "../types/appointmentTypes";

function createAppointmentApiService() {
  const api = createApiService("appointments");
  const businessApi = createApiService("businesses");

  return {
    reviewForms: async (businessId: string, serviceIds: string[], appointmentId?: string, expectedRevision?: number, signal?: AbortSignal): Promise<AppointmentFormsReviewDto> => {
      return businessApi.post<AppointmentFormsReviewDto>(`/${businessId}/appointments/forms/review`, {
        service_ids: serviceIds, appointment_id: appointmentId, expected_revision: expectedRevision,
      }, { signal });
    },
    getEvents: async (businessId: string, id: string, signal?: AbortSignal): Promise<AppointmentEventDto[]> => {
      return businessApi.get<AppointmentEventDto[]>(`/${businessId}/appointments/${id}/events`, { signal });
    },
    getAll: async (businessId: string): Promise<AppointmentDto[]> => {
      return api.get<AppointmentDto[]>(`/?businessId=${businessId}`);
    },

    getById: async (id: string): Promise<AppointmentDto> => {
      return api.get<AppointmentDto>(`/${id}`);
    },

    create: async (data: CreateAppointmentDto): Promise<AppointmentDto> => {
      return api.post<AppointmentDto>("", data);
    },

    update: async (
      id: string,
      data: UpdateAppointmentDto
    ): Promise<AppointmentDto> => {
      return api.put<AppointmentDto>(`/${id}`, data);
    },

    confirm: async (id: string): Promise<AppointmentDto> => {
      return api.post<AppointmentDto>(`/${id}/confirm`, {});
    },

    cancel: async (id: string): Promise<AppointmentDto> => {
      return api.post<AppointmentDto>(`/${id}/cancel`, {});
    },

  };
}

const appointmentApiService = createAppointmentApiService();
export { appointmentApiService };
